<template>
  <div class="tips">
    <div class="tips-item" v-if="showItem == 'licenseImg'">
      <p class="title">营业执照照片</p>
      <div class="requirement">
        <p class="r-title">图片要求</p>
        <ol class="r-content r-ol">
          <li>
            需提供三证合一/二证合一的营业执照原件扫描件或加盖公司鲜章的复印件
          </li>
          <li>确保未在企业经营异常名录中，且所售商品在营业执照经营范围内</li>
          <li>露出证件四角，请勿遮挡或模糊，保持信息清晰可见</li>
          <li>
            图片尺寸为800*800px以上，支持PNG、JPG和JPEG格式，大小不超过5MB
          </li>
          <li>
            由于国家系统未能实时更新新注册营业执照的数据，建议您自营业执照注册之日起【14个工作日】后再入驻。
          </li>
        </ol>
      </div>
      <div class="reminder">
        <p class="r-title">审核提醒</p>
        <p class="r-content">需审核通过后生效</p>
      </div>
      <div class="example">
        <p class="r-title">示例</p>
        <img
          class="e-img"
          src="@/assets/images/simulation/licenseImg.png"
          alt=""
        />
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'companyName'">
      <p class="title">公司名称</p>
      <div class="requirement">
        <p class="r-title">填写规则</p>
        <ol class="r-content r-ol">
          <li>需和营业执照上的公司“名称”保持一致；</li>
          <li>
            若您营业执照的公司名称为星号或空白等，暂不支持入驻，请先前往工商局添加公司名称。
          </li>
        </ol>
      </div>
      <div class="reminder">
        <p class="r-title">审核提醒</p>
        <p class="r-content">需审核通过后生效</p>
      </div>
      <div class="example">
        <p class="r-title">示例</p>
        <img
          class="e-img"
          :src="
            $route.query.type == 1
              ? require('@/assets/images/simulation/companyNameImg.png')
              : require('@/assets/images/simulation/companyNameImg_c.png')
          "
          alt=""
        />
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'crediCode'">
      <p class="title">统一社会信用代码</p>
      <div class="warn">
        <i class="warn-icon el-icon-warning"></i>
        <p class="warn-text">
          目前仅支持18位统一社会信用代码，若非18位，需要到工商局升级营业执照。
        </p>
      </div>
      <div class="requirement">
        <p class="r-title">填写规则</p>
        <ol class="r-content r-ol">
          <li>请与营业执照上保持一致，英文字母大写</li>
          <li>统一社会信用代码用于后续开户、结算等核心流程，请务必再次核对;</li>
          <li>
            目前仅支持18位统一社会信用代码，若非18位，需要到工商局升级营业执照。
          </li>
        </ol>
      </div>
      <div class="reminder">
        <p class="r-title">审核提醒</p>
        <p class="r-content">需审核通过后生效</p>
      </div>
      <div class="example">
        <p class="r-title">示例</p>
        <img
          class="e-img"
          :src="
            $route.query.type == 1
              ? require('@/assets/images/simulation/crediCodeImg.png')
              : require('@/assets/images/simulation/crediCodeImg_c.png')
          "
          alt=""
        />
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'date'">
      <p class="title">营业期限</p>
      <div class="requirement">
        <p class="r-title">填写规则</p>
        <ol class="r-content r-ol">
          <li>需和营业执照上的“经营期限”保持一致；</li>
          <li>若营业执照没有营业期限，请勾选“长期”选项；</li>
          <li>距离有效期截止时间应大于15天。</li>
        </ol>
      </div>
      <div class="reminder">
        <p class="r-title">审核提醒</p>
        <p class="r-content">需审核通过后生效</p>
      </div>
      <div class="example">
        <p class="r-title">示例</p>
        <img
          class="e-img"
          :src="
            $route.query.type == 1
              ? require('@/assets/images/simulation/dateImg.png')
              : require('@/assets/images/simulation/dateImg_c.png')
          "
          alt=""
        />
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'address'">
      <p class="title">经营地址</p>
      <div class="requirement">
        <p class="r-title">填写规则</p>
        <p class="r-content">需和营业执照的注册地址保持一致</p>
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'personAddress'">
      <p class="title">
        {{ $route.query.type == 1 ? "经营者" : "法定代表人" }}身份归属地
      </p>
      <div class="requirement">
        <p class="r-title">填写规则</p>
        <p class="r-content">请根据将要上传的身份证明材料，选择对应的所在地</p>
      </div>
      <div class="reminder">
        <p class="r-title">审核提醒</p>
        <p class="r-content">需审核通过后生效</p>
      </div>
      <div class="requirement">
        <p class="r-title">修改规则</p>
        <p class="r-content">
          正式营业后可再次编辑，修改后需再次提交审核，通过后生效
        </p>
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'uploadType'">
      <p class="title">境内上传方式</p>
      <div class="requirement">
        <p class="r-title">暂无提示</p>
      </div>
    </div>

    <div
      class="tips-item"
      v-if="showItem == 'frontIdCard' || showItem == 'backIdCard'"
    >
      <p class="title">
        {{ showItem == "frontIdCard" ? "身份证人像面" : "身份证国徽面" }}
      </p>
      <div class="requirement">
        <p class="r-title">图片要求</p>
        <ol class="r-content r-ol">
          <li>身份证须使用二代身份证；</li>
          <li>企业须提供法定代表人身份证；个体工商户需提供经营者身份证。</li>
          <li>
            请提供有效期限范围内的证件，证件需露出四角，请勿遮挡或模糊，保持信息清晰可见
          </li>
          <li>
            图片尺寸为800*800px以上，支持PNG、JPG和JPEG格式，大小不超过5MB
          </li>
        </ol>
      </div>
      <div class="reminder">
        <p class="r-title">审核提醒</p>
        <p class="r-content">需审核通过后生效</p>
      </div>
      <div class="example">
        <p class="r-title">示例</p>
        <img
          v-if="showItem == 'frontIdCard'"
          class="e-img"
          src="@/assets/images/simulation/frontIdCardImg.png"
          alt=""
        />
        <img
          v-else
          class="e-img"
          src="@/assets/images/simulation/backIdCardImg.png"
          alt=""
        />
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'realName'">
      <p class="title">
        {{ $route.query.type == 1 ? "经营者" : "法定代表人" }}姓名
      </p>
      <div class="requirement">
        <p class="r-title">填写规则</p>
        <ol class="r-content r-ol">
          <li>
            请输入营业执照上登记的{{
              $route.query.type == 1 ? "经营者" : "法定代表人"
            }}姓名;
          </li>
        </ol>
      </div>
      <div class="reminder">
        <p class="r-title">审核提醒</p>
        <p class="r-content">需审核通过后生效</p>
      </div>
      <div class="example">
        <p class="r-title">示例</p>
        <img
          class="e-img"
          :src="
            $route.query.type == 1
              ? require('@/assets/images/simulation/realNameImg.png')
              : require('@/assets/images/simulation/realNameImg_c.png')
          "
          alt=""
        />
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'idNumber'">
      <p class="title">
        {{ $route.query.type == 1 ? "经营者" : "法定代表人" }}身份证号码
      </p>
      <div class="requirement">
        <p class="r-title">填写规则</p>
        <ol class="r-content r-ol">
          <li>
            请输入与{{
              $route.query.type == 1 ? "经营者" : "法定代表人"
            }}姓名一致的身份证号码;
          </li>
        </ol>
      </div>
      <div class="reminder">
        <p class="r-title">审核提醒</p>
        <p class="r-content">需审核通过后生效</p>
      </div>
      <div class="example">
        <p class="r-title">示例</p>
        <img
          class="e-img"
          src="@/assets/images/simulation/idNumberImg.png"
          alt=""
        />
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'idCardDate'">
      <p class="title">
        {{ $route.query.type == 1 ? "经营者" : "法定代表人" }}身份证有效期
      </p>
      <div class="requirement">
        <p class="r-title">填写规则</p>
        <ol class="r-content r-ol">
          <li>证件需在有效期内；</li>
          <li>需和身份证上的有效期保持一致；</li>
          <li>若证件有效期为长期，请勾选“长期”选项。</li>
        </ol>
      </div>
      <div class="reminder">
        <p class="r-title">审核提醒</p>
        <p class="r-content">需审核通过后生效</p>
      </div>
      <div class="example">
        <p class="r-title">示例</p>
        <img
          class="e-img"
          src="@/assets/images/simulation/idCardDateImg.png"
          alt=""
        />
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'shopType'">
      <p class="title">店铺类型</p>
      <div class="requirement">
        <p class="r-title">选项说明</p>
        <div class="r-content">
          <div class="one-tip">
            <p><span class="dot"></span>普通店:</p>
            <div class="one-content">
              <p>针对无品牌的商家适合选择该店铺类型；</p>
              <p>
                申请主体为企业、个体工商户或个人（新个人商家入驻已暂停，已入驻商家可正常经营）；
              </p>
              <p>完成入驻后可修改为其他店铺类型</p>
            </div>
          </div>
          <div class="one-tip">
            <p><span class="dot"></span>专卖店:</p>
            <div class="one-content">
              <p>适合经营1个品牌的商家；</p>
              <p>经营1个授权品牌（商标为R状态）；</p>
              <p>完成入驻后可修改为其他店铺类型</p>
            </div>
          </div>
          <div class="one-tip">
            <p><span class="dot"></span>专营店:</p>
            <div class="one-content">
              <p>适合经营2个及以上品牌的商家；</p>
              <p>专营店有以下3种情形：</p>
              <p>① 经营2个及以上他人授权品牌</p>
              <p>② 既经营他人授权品牌又经营自有品牌</p>
              <p>③ 经营2个及以上自有品牌</p>
              <p>完成入驻后可修改为其他店铺类型</p>
            </div>
          </div>
          <div class="one-tip">
            <p><span class="dot"></span>旗舰店:</p>
            <div class="one-content">
              <p>可经营1个或多个自有品牌；</p>
              <p>
                可经营1个或多个一级独占授权品牌，多个授权品牌需属于同一商标所有人；
              </p>
              <p>自有品牌：商标为R标或TM标均可；</p>
              <p>授权品牌：商标为R标才可以进行授权；</p>
              <p>完成入驻后不支持修改为其他店铺类型。</p>
            </div>
          </div>
        </div>
      </div>
      <div class="requirement">
        <p class="r-title">修改规则</p>
        <p class="r-content">
          正式营业后可再次编辑，修改后需再次提交审核，通过后生效
        </p>
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'qjAscription'">
      <p class="title">旗舰店品牌归属</p>
      <div class="warn or">
        <i class="warn-icon el-icon-warning"></i>
        <p class="warn-text">
          切换品牌归属，下方已上传的品牌资质，需要重新上传；若旗舰店品牌归属审核通过，品牌归属不能修改，请谨慎选择。
        </p>
      </div>
      <div class="requirement">
        <p class="r-title">选项说明</p>
        <ol class="r-content r-ol">
          <li>自有品牌：</li>
          <p>指商标注册人为营业执照上的公司主体</p>
          <li>授权品牌：</li>
          <p>指商标注册人非营业执照上的公司主体，需提供商标所有人的授权文件</p>
        </ol>
        <div class="requirement">
          <p class="r-title">修改规则</p>
          <p class="r-content">
            正式营业后可再次编辑，修改后需再次提交审核，通过后生效
          </p>
        </div>
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'PTshop'">
      <p class="title">店铺名称</p>
      <div class="requirement">
        <p class="r-title">填写规则</p>
        <div class="r-content">
          <div class="one-tip">
            <p><span class="dot"></span>普通店:</p>
            <div class="one-content">
              <p>形式：商家自定义即可</p>
              <p>
                要求：店铺名称中不得含有政治敏感、平台禁售商品及任何联系方式（电话号码、网址、二维码，微信号等）及特殊符号
              </p>
            </div>
          </div>
        </div>
        <div class="reminder">
          <p class="r-title">审核提醒</p>
          <p class="r-content">需审核通过后生效</p>
        </div>
        <div class="requirement">
          <p class="r-title">修改规则</p>
          <p class="r-content">
            正式营业后可再次编辑，修改后需再次提交审核，通过后生效
          </p>
        </div>
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'ZYshop'">
      <p class="title">店铺名称</p>
      <div class="requirement">
        <p class="r-title">填写规则</p>
        <div class="r-content">
          <div class="one-tip">
            <p><span class="dot"></span>专营店:</p>
            <div class="one-content">
              <p>
                请输入企业商号+类目名，企业商号是你公司的关键词，用于区别其他公司
              </p>
              <p>
                例：良米数码专卖店，“良米”则为你的企业商号，“数码”则为你的类目名。
              </p>
            </div>
          </div>
        </div>
        <div class="reminder">
          <p class="r-title">审核提醒</p>
          <p class="r-content">需审核通过后生效</p>
        </div>
        <div class="requirement">
          <p class="r-title">修改规则</p>
          <p class="r-content">
            正式营业后可再次编辑，修改后需再次提交审核，通过后生效
          </p>
        </div>
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'ZMshop'">
      <p class="title">店铺名称</p>
      <div class="requirement">
        <p class="r-title">填写规则</p>
        <div class="r-content">
          <div class="one-tip">
            <p><span class="dot"></span>专卖店:</p>
            <div class="one-content">
              <p>
                请输入品牌名+企业商号（选填），企业商号是你公司的关键词，用于区别其他公司。
              </p>
              <p>
                例：小米良米数码科技有限公司，“小米”则为你的品牌名，“良米”则为你的企业商号。
              </p>
            </div>
          </div>
        </div>
        <div class="reminder">
          <p class="r-title">审核提醒</p>
          <p class="r-content">需审核通过后生效</p>
        </div>
        <div class="requirement">
          <p class="r-title">修改规则</p>
          <p class="r-content">
            正式营业后可再次编辑，修改后需再次提交审核，通过后生效
          </p>
        </div>
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'QJshop'">
      <p class="title">店铺名称</p>
      <div class="requirement">
        <p class="r-title">填写规则</p>
        <div class="r-content">
          <div class="one-tip">
            <p><span class="dot"></span>旗舰店:</p>
            <div class="one-content">
              <p>
                请输入品牌名+类目名（选填），若为自有商标，请选择官方旗舰店；若非自有商标，请选择旗舰店
              </p>
              <p>
                例：小米数码官方旗舰店，“小米”则为你的自有品牌名，“数码”则为你的类目名。
              </p>
            </div>
          </div>
        </div>
        <div class="reminder">
          <p class="r-title">审核提醒</p>
          <p class="r-content">需审核通过后生效</p>
        </div>
        <div class="requirement">
          <p class="r-title">修改规则</p>
          <p class="r-content">
            正式营业后可再次编辑，修改后需再次提交审核，通过后生效
          </p>
        </div>
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'logo'">
      <p class="title">店铺logo</p>
      <div class="requirement">
        <p class="r-title">图片要求</p>
        <ol class="r-content r-ol">
          <li>logo中不得侵权和涉及第三方版权素材</li>
          <li>logo中含有品牌信息时需提供相应授权</li>
          <li>露出证件四角，请勿遮挡或模糊，保持信息清晰可见</li>
          <li>
            logo中不得含有政治敏感、平台禁售商品及任何联系方式（电话号码、网址、二维码，微信号等）
          </li>
          <li>logo中不得使用资质，合同类图片</li>
          <li>
            图片尺寸为800*800px以上，支持PNG、JPG和JPEG格式，大小不超过5MB
          </li>
        </ol>
      </div>
      <div class="reminder">
        <p class="r-title">审核提醒</p>
        <p class="r-content">需审核通过后生效</p>
      </div>
      <div class="requirement">
        <p class="r-title">修改规则</p>
        <p class="r-content">
          正式营业后可再次编辑，修改后需再次提交审核，通过后生效
        </p>
      </div>
      <div class="example">
        <p class="r-title">示例</p>
        <img
          class="e-img"
          src="@/assets/images/simulation/logoImg.png"
          alt=""
        />
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'portrait'">
      <p class="title">肖像授权书</p>
      <div class="requirement">
        <p class="r-title">图片要求</p>
        <ol class="r-content r-ol">
          <li>
            授权范围/渠道：电商平台/渠道、互联网平台/渠道、线上平台/渠道，所有销售推广渠道，范围需在覆盖在范围内；
          </li>
          <li>
            被授权方需为公司（商品品牌方、店铺主体），不可以是商品或者电视节目；
          </li>
          <li>需明确肖像使用有效时间，且在有效期内；</li>
        </ol>
      </div>
      <div class="reminder">
        <p class="r-title">审核提醒</p>
        <p class="r-content">需审核通过后生效</p>
      </div>
      <div class="requirement">
        <p class="r-title">修改规则</p>
        <p class="r-content">
          正式营业后可再次编辑，修改后需再次提交审核，通过后生效
        </p>
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'portraitDate'">
      <p class="title">肖像授权书有效期</p>
      <div class="requirement">
        <p class="r-title">图片要求</p>
        <p class="r-content">
          请填写肖像授权书上的有效期，若有效期为长期，请勾选长期
        </p>
      </div>
      <div class="reminder">
        <p class="r-title">审核提醒</p>
        <p class="r-content">需审核通过后生效</p>
      </div>
      <div class="requirement">
        <p class="r-title">修改规则</p>
        <p class="r-content">
          正式营业后可再次编辑，修改后需再次提交审核，通过后生效
        </p>
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'category'">
      <p class="title">经营类目</p>
      <div class="requirement">
        <p class="r-title">填写规则</p>
        <ol class="r-content r-ol">
          <li>
            营业执照经营范围内的类目都可选择，保证金按所选类目中金额最高的缴纳。具体保证金标准可查看
            <a
              class="link"
              href="https://school.jinritemai.com/doudian/web/article/101816"
              target="_blank"
              rel="noopener noreferrer"
              >《保证金标准》</a
            >
          </li>
          <li>
            当前所选类目对应商品产生的订单在结算时，平台会按订单金额收取技术服务费，具体技术服务费标准可查看
            <a
              class="link"
              href="https://school.jinritemai.com/doudian/web/article/106833"
              target="_blank"
              rel="noopener noreferrer"
              >《技术服务费标准》</a
            >
          </li>
        </ol>
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'administrator'">
      <p class="title">管理人姓名</p>
      <div class="requirement">
        <p class="r-title">填写规则</p>
        <p class="r-content">请填写管理人姓名</p>
      </div>
      <div class="reminder">
        <p class="r-title">审核提醒</p>
        <p class="r-content">需审核通过后生效</p>
      </div>
      <div class="requirement">
        <p class="r-title">修改规则</p>
        <p class="r-content">
          正式营业后可再次编辑，修改后需再次提交审核，通过后生效
        </p>
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'administratorMobile'">
      <p class="title">管理人手机号</p>
      <div class="warn or">
        <i class="warn-icon el-icon-warning"></i>
        <p class="warn-text">
          此手机号作为唯一用于订单下载和资金结算，请谨慎填写
        </p>
      </div>
      <div class="requirement">
        <p class="r-title">填写规则</p>
        <p class="r-content">请填写管理人手机号</p>
      </div>
      <div class="reminder">
        <p class="r-title">审核提醒</p>
        <p class="r-content">需审核通过后生效</p>
      </div>
      <div class="requirement">
        <p class="r-title">修改规则</p>
        <p class="r-content">
          正式营业后可再次编辑，修改后需再次提交审核，通过后生效
        </p>
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'brandCategory'">
      <p class="title">所属类目</p>
      <div class="requirement">
        <p class="r-title">填写规则</p>
        <p class="r-content">请从您的经营类目中选择其中的一个或多个</p>
      </div>
      <div class="reminder">
        <p class="r-title">审核提醒</p>
        <p class="r-content">需审核通过后生效</p>
      </div>
      <div class="requirement">
        <p class="r-title">修改规则</p>
        <p class="r-content">
          正式营业后可再次编辑，修改后需再次提交审核，通过后生效
        </p>
      </div>
      <div class="example">
        <p class="r-title">示例</p>
        <img
          class="e-img"
          src="@/assets/images/simulation/brandCategoryImg.png"
          alt=""
        />
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'trademarkingNumber'">
      <p class="title">商标注册号</p>
      <div class="requirement">
        <p class="r-title">填写规则</p>
        <p class="r-content">需与商标注册证上的商标注册号保持一致</p>
      </div>
      <div class="reminder">
        <p class="r-title">审核提醒</p>
        <p class="r-content">需审核通过后生效</p>
      </div>
      <div class="requirement">
        <p class="r-title">修改规则</p>
        <p class="r-content">
          正式营业后可再次编辑，修改后需再次提交审核，通过后生效
        </p>
      </div>
      <div class="example">
        <p class="r-title">示例</p>
        <img
          class="e-img"
          src="@/assets/images/simulation/trademarkingNumberImg.png"
          alt=""
        />
      </div>
    </div>

    <div
      class="tips-item"
      v-if="showItem == 'chineseBrand' || showItem == 'englishBrand'"
    >
      <p class="title">
        品牌{{ showItem == "chineseBrand" ? "中文" : "英文" }}名
      </p>
      <div class="requirement">
        <p class="r-title">填写规则</p>
        <p class="r-content">
          需与商标注册证中的{{
            showItem == "chineseBrand" ? "中文部分" : "英文名称"
          }}保持一致
        </p>
      </div>
      <div class="reminder">
        <p class="r-title">审核提醒</p>
        <p class="r-content">需审核通过后生效</p>
      </div>
      <div class="requirement">
        <p class="r-title">修改规则</p>
        <p class="r-content">
          正式营业后可再次编辑，修改后需再次提交审核，通过后生效
        </p>
      </div>
      <div class="example">
        <p class="r-title">示例</p>
        <img
          class="e-img"
          :src="
            showItem == 'chineseBrand'
              ? require('@/assets/images/simulation/chineseBrandImg.png')
              : require('@/assets/images/simulation/englishBrandImg.png')
          "
          alt=""
        />
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'registrant'">
      <p class="title">商标注册人</p>
      <div class="requirement">
        <p class="r-title">填写规则</p>
        <p class="r-content">需与商标注册证上的商标注册人保持一致</p>
      </div>
      <div class="reminder">
        <p class="r-title">审核提醒</p>
        <p class="r-content">需审核通过后生效</p>
      </div>
      <div class="requirement">
        <p class="r-title">修改规则</p>
        <p class="r-content">
          正式营业后可再次编辑，修改后需再次提交审核，通过后生效
        </p>
      </div>
      <div class="example">
        <p class="r-title">示例</p>
        <img
          class="e-img"
          src="@/assets/images/simulation/registrantImg.png"
          alt=""
        />
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'brandType'">
      <p class="title">品牌经营类型</p>
      <div class="requirement">
        <p class="r-title">暂无提示</p>
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'trademarkingDate'">
      <p class="title">商标注册有效期</p>
      <div class="requirement">
        <p class="r-title">填写规则</p>
        <p class="r-content">
          请填写商标注册证上的有效期，若有效期为长期，请勾选长期
        </p>
      </div>
      <div class="reminder">
        <p class="r-title">审核提醒</p>
        <p class="r-content">需审核通过后生效</p>
      </div>
      <div class="requirement">
        <p class="r-title">修改规则</p>
        <p class="r-content">
          正式营业后可再次编辑，修改后需再次提交审核，通过后生效
        </p>
      </div>
      <div class="example">
        <p class="r-title">示例</p>
        <img
          class="e-img"
          src="@/assets/images/simulation/trademarkingDateImg.png"
          alt=""
        />
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'certificate'">
      <p class="title">商标注册证</p>
      <div class="requirement">
        <p class="r-title">图片要求</p>
        <ol class="r-content r-ol">
          <li>
            请上传商标注册证或商标注册申请受理通知书,商标为R标请上传商标注册证，商标为TM标请上传商标注册申请受理通知书（若办理过变更、转让、续展，请同时上传商标总局颁发的变更、转让、续展证明或受理通知书）
          </li>
          <li>
            请提供有效期内的商标注册证，露出证件四角，请勿遮挡或模糊，保持信息清晰可见
          </li>
          <li>
            请提供原件扫描件或复印件的扫描件，注意：复印件上需加盖开店公司公章/商标注册人公司公章
          </li>
          <li>
            商标注册证为个人注册时，需提供商标注册人的身份证正反面照片，如提供复印件，需提供商标注册人手写签名；
          </li>
          <li>
            图片尺寸为800*800px以上，支持PNG、JPG和JPEG格式，大小不超过5MB
          </li>
        </ol>
      </div>
      <div class="reminder">
        <p class="r-title">审核提醒</p>
        <p class="r-content">需审核通过后生效</p>
      </div>
      <div class="requirement">
        <p class="r-title">修改规则</p>
        <p class="r-content">
          正式营业后可再次编辑，修改后需再次提交审核，通过后生效
        </p>
      </div>
      <div class="example">
        <p class="r-title">示例</p>
        <img
          class="e-img"
          src="@/assets/images/simulation/certificateImg.png"
          alt=""
        />
      </div>
    </div>

    <div class="tips-item" v-if="showItem == 'authorizationLink'">
      <p class="title">品牌授权链路</p>
      <div class="requirement">
        <p class="r-title">暂无提示</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showItem: String,
  },
};
</script>

<style lang="less" scoped>
.tips {
  width: 100%;
  text-align: left;

  .tips-item {
    .title {
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
    }

    .warn,
    .example,
    .reminder,
    .requirement {
      margin-top: 16px;

      &.warn {
        padding: 8px;
        background-color: rgba(25, 102, 255, 0.08);
        border-radius: 4px;
        font-size: 12px;

        &.or {
          background-color: rgba(255, 159, 25, 0.08);
          .warn-icon {
            color: #ff9f19;
          }
        }
        .warn-icon {
          display: inline-block;
          color: #1966ff;
        }

        .warn-text {
          display: inline-block;
          margin-left: 8px;
          width: 91%;
          color: #252931;
          line-height: 16px;
          vertical-align: top;
        }
      }

      .r-title {
        margin-bottom: 6px;
        font-size: 12px;
      }

      .r-content {
        color: #85878a;
        font-size: 12px;
        line-height: 16px;

        &.r-ol {
          padding-left: 14px;
          list-style: decimal;

          li {
            margin-top: 4px;
          }
        }

        .one-tip {
          margin-bottom: 6px;

          .dot {
            display: inline-block;
            width: 4px;
            height: 4px;
            background: rgba(0, 0, 0, 0.25);
            border-radius: 50%;
            margin-right: 4px;
            vertical-align: middle;
          }

          .one-content {
            padding-left: 8px;
          }
        }

        .link {
          margin-left: 8px;
          color: #1966ff;
          &:hover {
            text-decoration: underline;
          }
        }
      }

      .e-img {
        width: 100%;
      }
    }
  }
}
</style>